import React from "react";
import {Table} from "react-bootstrap";
import {wizardFormQuantity} from "../../../../../util/Constants";
import moment from "moment";
import k1utils from "../../../../../util/k1utils";

export function WizardFormSection({ data }) {
  const keyData = data;
  const order_value = keyData?.order_value;

  return (
    <div>
      {/* 주문서에 주문자 정보 표시 */}
      {keyData && (
        <Table bordered striped>
          <tbody>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                이름
              </th>
              <td>{keyData.buyer_name}</td>
            </tr>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                연락처
              </th>
              <td>{k1utils.phoneNumberFormat(keyData.buyer_phone_number)}</td>
            </tr>
            <tr className='p-0'>
              <th className='bg-dark text-white'>
                픽업
              </th>
              <td>{moment(keyData.pickup_dtm).format('YYYY-MM-DD HH:mm')}</td>
            </tr>
          </tbody>
        </Table>
      )}
      <Table striped bordered hover>
        <thead className="thead-dark">
          <tr>
            <th>항목</th>
            <th>선택</th>
          </tr>
        </thead>
        <tbody>
          {
            order_value &&
            order_value
              .filter(value => !(value.musthave === "N" && (value.direct_text === "" && !value.is_checked)))
              .sort((a, b) => a.t_order_itemidx - b.t_order_itemidx)
              .map((item, i) => {
                if (item.t_order_item_name === "배송 여부") return false;
                return (
                  <tr key={"order_value-" + i}>
                    <td>{item.t_order_item_name}</td>
                    <td>
                                    {(item.t_item_option_name + (item.t_item_suboption_name ? `-${item.t_item_suboption_name}` : '')) || (item.is_checked && (item.direct_text ? item.direct_text : (item.t_order_item_name === wizardFormQuantity ? '1' : 'Y'))) || (item.direct_text)}
                    </td>
                  </tr>
                )
                    }
                )
            }

        </tbody>
      </Table>
    </div>
  )
}